// @flow
import React from 'react'
import glamorous from 'glamorous'
import PropTypes from 'prop-types'
import content from 'pp-react-l10n'
import { connect } from '../../utils/p2p-connect'
import { Alert } from '@paypalcorp/pp-react'

let i18n = content('transfer/alert')

const FFFMessageContainer = glamorous.div({
  display: 'flex',
  margin: '1rem 0',
})

const FFFInfoMessage = props => {
  return (
    <FFFMessageContainer>
      <Alert type="warning" typeIconAriaLabel={i18n('warning.icon.label')}>
        {props.firstFeeFreeContents.thresholdFeeAmountMessage}
      </Alert>
    </FFFMessageContainer>
  )
}

FFFInfoMessage.propTypes = {
  firstFeeFreeContents: PropTypes.object,
  firstFeeFreeThresholdAmount: PropTypes.object,
}

export default connect(({ transaction }) => ({
  firstFeeFreeContents: transaction.firstFeeFreeContents,
  firstFeeFreeThresholdAmount: transaction.firstFeeFreeThresholdAmount,
}))(FFFInfoMessage)
